<template>
  <el-card class="app-table-container" :body-style="{ padding: '20px' }">
    <div slot="header">
      <div class="global-table-header">
        <div></div>
        <!-- <list-search ref="listSearch" @listSearchEvn="listSearchEvn" /> -->
        <button class="global-button-style" @click="add">
          新建
        </button>
      </div>
    </div>
    <div class="global-body-wrap">
      <AppTable
        :tableProps="tableProps"
        :tableData="tableData"
        :currentPage="params.page"
        :pageSize="params.limit"
        :showHeader="false"
        @tableHandle="tableHandle"
        @switchChange="switchChange"
      />
    </div>
    <Pagination :pageSize="params.limit" :total="total" @pageNum="pageNum" />
    <el-dialog
      :title="title"
      :visible.sync="centerDialogVisible"
      width="500px"
      center
      @close="initForm"
    >
      <div>
        <el-form :model="form" ref="form" label-width="80px">
          <el-form-item label="标题">
            <el-input v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item label="回复方式">
            <el-select v-model="form.reply">
              <el-option label="每次" value="0"> </el-option>
              <el-option label="仅回复一次" value="1"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关键字">
            <el-input v-model="keywords"></el-input>
            <span>（多个关键字必须以"\"隔开）</span>
          </el-form-item>
          <el-form-item label="中文">
            <el-input
              type="textarea"
              :rows="4"
              v-model="form.content.zh"
            ></el-input>
          </el-form-item>
          <el-form-item label="英文">
            <el-input
              type="textarea"
              :rows="4"
              v-model="form.content.en"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="createMsg">确 定</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import AppTable from "@/components/appTable";
import Pagination from "@/components/pagination";
import ListSearch from "@/components/listSearch";

export default {
  components: {
    AppTable,
    ListSearch,
    Pagination
  },
  computed: {
    tableProps() {
      let tableProps = [
        {
          prop: "title"
        },
        {
          prop: "keywords"
        },
        {
          prop: "reply"
        },
        {
          prop: "handle",
          width: 200,
          btn: [this.$t("commonMsg.edit"), this.$t("commonMsg.del")]
        }
      ];
      return tableProps;
    }
  },
  data() {
    return {
      tableData: [],
      total: 0,
      params: { limit: 20, page: 1, type: 2 },
      centerDialogVisible: false,
      itemID: "",
      title: "新建",
      handleType: false,
      keywords: "",

      form: {
        title: "",
        reply: "1",
        content: {
          zh: "",
          en: ""
        },
        type: 2
      }
    };
  },
  methods: {
    add() {
      this.title = "新建";
      this.keywords = "";
      this.centerDialogVisible = true;
    },
    getBotMsg() {
      this.$http.getBotMsg(this.params).then(res => {
        this.tableData = res.data.results;
        this.total = res.data.count;
      });
    },
    async createMsg() {
      try {
        this.form.keywords = this.keywords.split("\\");
        if (this.title === "新建") {
          await this.$http.createBotMsg(this.form);
          this.getBotMsg();
          this.centerDialogVisible = false;
          this.elMsg("创建成功", "success");
        } else {
          await this.$http.updateBotMsg(this.itemID, this.form);
          this.getBotMsg();
          this.centerDialogVisible = false;
          this.elMsg("编辑成功", "success");
        }
      } catch ({ response }) {
        this.elMsg(response.data.message, "error");
      }
    },
    initForm() {
      for (let i in this.form) {
        if (i === "status" || i === "type") continue;
        if (i === "content") {
          this.form[i].zh = "";
          this.form[i].en = "";
        } else if (i === "reply") {
          this.form[i] = "1";
        } else {
          this.form[i] = "";
        }
      }
    },
    switchChange({ data }) {
      let params = data.row;
      this.$http.updateBotMsg(params._id, params);
    },
    delBotMsg(params) {
      this.$http.delBotMsg(params._id).then(res => {
        this.getBotMsg();
        this.elMsg("删除成功", "success");
      });
    },
    tableHandle({ type, data }) {
      if (type === this.$t("commonMsg.del")) {
        this.delBotMsg(data.row);
      } else if (type === this.$t("commonMsg.edit")) {
        this.itemID = data.row._id;
        this.form.title = data.row.title;
        this.form.reply = data.row.reply;
        this.form.content.zh = data.row.content.zh;
        this.form.content.en = data.row.content.en;
        this.keywords = data.row.keywords.join("\\");
        this.title = "编辑";
        this.centerDialogVisible = true;
      }
    },
    listSearchEvn() {},
    pageNum(page) {
      this.params.page = page;
      this.getBotMsg();
    }
  },
  mounted() {
    this.getBotMsg();
  }
};
</script>
